import React, { useState, useRef, useEffect } from 'react';
import { useContext } from 'react';
import { CartContext } from '../../context/CartContext';
import { ServiceContext } from '../../context/ServiceContext';
import LoadingOverlay from '../../components/loadingOverlay/loadingOverlay';
import axios from 'axios';
import { Progress } from 'antd';
import { useParams, useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import './orderResult.css'

function OrderResult() {
    const navigate = useNavigate();
    const { setCartFromRemote } = useContext(CartContext);
    const resultMounted = useRef(false);
    useEffect(() => {
        resultMounted.current = true;
        return () => { resultMounted.current = false; };
    }, []);
    const {tableNumber,setTableNumber,uiLanguage,setDineInGuestCount}= useContext(ServiceContext);
    // const { tableNumber, setTableNumber, storeName, storeId } = useContext(ServiceContext);
    const [storeName, setStoreName] = useState('');
    const [usePickupSlip, setUsePickupSlip] = useState('');
    const [payLaterReminderEnable, setPayLaterReminderEnable] = useState('');
    const [payLaterReminderText, setPayLaterReminderText] = useState('');
    const [payFirstReminderEnable, setPayFirstReminderEnable] = useState('');
    const [payFirstReminderText, setPayFirstReminderText] = useState('');
    const [takeawayReminderEnable, setTakeawayReminderEnable] = useState('');
    const [takeawayReminderText, setTakeawayReminderText] = useState('');
    const [orderTime, setOrderTime] = useState('');
    const [orderEnrichNo, setOrderEnrichNo] = useState('');
    const [orderSuccess, setOrderSuccess] = useState(null);
    const [serviceMode, setServiceMode] = useState('');

    const [paymentId, setPaymentId] = useState('');
    const [OrderDetails, setOrderDetails] = useState('');
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalGST, setTotalGST] = useState(0);
    const [surcharges, setSurcharges] = useState(0);
    const [notes, setNotes] = useState('');
    const [promotionTitle, setPromotionTitle] = useState('');
    const [promotionAmount, setPromotionAmount] = useState(0);
    const [crmPoints, setCrmPoints] = useState(null);
    const [totalItemQuantity, setTotalItemQuantity] = useState(0);
    const { restaurantUrl, orderId } = useParams();
    const [searchParams] = useSearchParams();
    
    // Customer Menu Show Price state
    const [showPriceInCustomerMenu, setShowPriceInCustomerMenu] = useState(true);
    
    // 检查URL参数，只有当从支付页面跳转回来时才显示进度条
    // 默认情况下不显示进度条
    const [isLoading, setIsLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const translations = {
        en: {
            orderDetails: 'Order Details',
            orderError: 'Order Error',
            orderErrorMessage: 'There was an error with your order.',
            contactsStaff: 'Please contact the staff.',
            inPreparation: 'In Preparation',
            pickupNo: 'Pickup No.',
            orderSuccessMessage: 'Your order has been successfully placed.',
            pending: 'Pending',
            pendingMessage: 'Please wait for the restaurant to confirm.',
            refresh: 'You can refresh the page later.',
            dineIn: 'Dine-in',
            takeAway: 'Take-away',
            delivery: 'Delivery',
            tableNo: 'Table No.',
            orderTime: 'Order Time',
            paymentId: 'Payment ID:',
            menuItems: 'Menu Items',
            notes: 'Notes',
            gst: 'GST',
            surcharge: 'Surcharge',
            pointsRedeemed: 'Points redeemed',
            total: 'Total (incl. GST)',
            done: 'Done',
            orderNo: 'Order No:',
            serviceType: 'Service Type',
            sendingOrder: 'Processing Order...',
            orderSuccessTitle: 'Order Successful',
            orderSuccessModalMessage: 'Order successful. Please go to the counter to pay after your meal.',
        },
        ja: {
            orderDetails: '注文の詳細',
            orderError: '注文エラー',
            orderErrorMessage: '注文中にエラーが発生しました。',
            contactsStaff: 'スタッフに連絡してください。',
            inPreparation: '準備中',
            pickupNo: '受け取り番号',
            orderSuccessMessage: '注文が正常に完了しました。',
            pending: '保留中',
            pendingMessage: 'レストランの確認をお待ちください。',
            refresh: '後でページを更新できます。',
            dineIn: '店内飲食',
            takeAway: '持ち帰り',
            delivery: 'Delivery',
            tableNo: 'テーブル番号',
            orderTime: '注文時間',
            paymentId: '支払いID：',
            menuItems: 'メニューアイテム',
            notes: '備考',
            gst: '消費税',
            surcharge: 'サーチャージ',
            pointsRedeemed: '利用ポイント',
            total: '合計（消費税込み）',
            done: '完了',
            orderNo: '注文番号: ',
            serviceType: 'サービスタイプ',
            sendingOrder: '注文を送信しています...',
            orderSuccessTitle: '注文成功',
            orderSuccessModalMessage: '注文が成功しました。お食事後はレジでお支払いください。',
        },
        zh: {
            orderDetails: '订单详情',
            orderError: '订单错误',
            orderErrorMessage: '您的订单出现错误.',
            contactsStaff: '请联系工作人员。',
            inPreparation: '准备中',
            pickupNo: '取餐号',
            orderSuccessMessage: '您的订单已成功下达。',
            pending: '待处理',
            pendingMessage: '请等待餐厅确认。',
            refresh: '稍后您可以刷新页面。',
            dineIn: '堂食',
            takeAway: '外卖',
            delivery: '配送',
            tableNo: '桌号',
            orderTime: '下单时间',
            paymentId: '支付编号：',
            menuItems: '菜品',
            notes: '备注',
            gst: '消费税',
            surcharge: '附加费',
            pointsRedeemed: '积分抵扣',
            total: '总计 (含GST)',
            done: '完成',
            orderNo: '订单编号：',
            serviceType: '服务类型',
            sendingOrder: '发送订单中...',
            orderSuccessTitle: '落单成功',
            orderSuccessModalMessage: '落单成功，用餐后请去收银台付款',
        },
        zf: {
            orderDetails: '訂單詳情',
            orderError: '訂單錯誤',
            orderErrorMessage: '您的訂單出現錯誤。',
            contactsStaff: '請聯繫工作人員。',
            inPreparation: '準備中',
            pickupNo: '取餐號',
            orderSuccessMessage: '您的訂單已成功下達。',
            pending: '待處理',
            pendingMessage: '請等待餐廳確認。',
            refresh: '稍後您可以刷新頁面。',
            dineIn: '堂食',
            takeAway: '外賣',
            delivery: '配送',
            tableNo: '桌號',
            orderTime: '下單時間',
            paymentId: '支付編號：',
            menuItems: '菜品',
            notes: '備註',
            gst: '消費稅',
            surcharge: '附加費',
            pointsRedeemed: '積分抵扣',
            total: '總計 (含GST)',
            done: '完成',
            orderNo: '訂單編號：',
            serviceType: '服務類型',
            sendingOrder: '發送訂單中...',
            orderSuccessTitle: '落單成功',
            orderSuccessModalMessage: '落單成功，用餐後請去收銀台付款',
        },        
        ko: {
            orderDetails: '주문 세부 정보',
            orderError: '주문 오류',
            orderErrorMessage: '주문 중 오류가 발생했습니다.',
            contactsStaff: '직원에게 문의하십시오.',
            inPreparation: '준비 중',
            pickupNo: '픽업 번호',
            orderSuccessMessage: '주문이 성공적으로 완료되었습니다.',
            pending: '보류 중',
            pendingMessage: '식당의 확인을 기다리십시오. ',
            refresh: '나중에 페이지를 새로 고칠 수 있습니다.',
            dineIn: '매장 식사',
            takeAway: '포장',
            delivery: 'Delivery',
            tableNo: '테이블 번호',
            orderTime: '주문 시간',
            paymentId: '결제 ID:',
            menuItems: '메뉴 항목',
            notes: '비고',
            gst: '부가세',
            surcharge: '추가 요금',
            pointsRedeemed: '사용 포인트',
            total: '합계 (GST 포함)',
            done: '완료',
            orderNo: '주문 번호: ',
            serviceType: '서비스 유형',
            sendingOrder: '주문 중...',
            orderSuccessTitle: '주문 성공',
            orderSuccessModalMessage: '주문이 성공했습니다. 식사 후 계산대에서 결제해 주세요.',
        },

        vi: {
            orderDetails: 'Chi tiết đơn hàng',
            orderError: 'Lỗi đơn hàng',
            orderErrorMessage: 'Có lỗi xảy ra với đơn hàng của bạn. ',
            contactsStaff: 'Vui lòng liên hệ nhân viên.',
            inPreparation: 'Đang chuẩn bị',
            pickupNo: 'Số lấy hàng',
            orderSuccessMessage: 'Đơn hàng của bạn đã được đặt thành công.',
            pending: 'Đang chờ xử lý',
            pendingMessage: 'Vui lòng đợi nhà hàng xác nhận. ',
            refresh: 'Bạn có thể làm mới trang sau.',
            dineIn: 'Dine-in',
            takeAway: 'Take-away',
            delivery: 'Delivery',
            tableNo: 'Số bàn',
            orderTime: 'Thời gian đặt hàng',
            paymentId: 'ID thanh toán:',
            menuItems: 'Mục menu',
            notes: 'Ghi chú',
            gst: 'Thuế GTGT',
            surcharge: 'Phụ phí',
            pointsRedeemed: 'Điểm đã đổi',
            total: 'Tổng cộng (bao gồm GST)',
            done: 'Hoàn tất',
            orderNo: 'Số đơn hàng: ',
            serviceType: 'Loại dịch vụ',
            sendingOrder: 'Đang giao hàng...',
            orderSuccessTitle: 'Đặt hàng thành công',
            orderSuccessModalMessage: 'Đặt hàng thành công. Vui lòng đến quầy thanh toán sau khi dùng bữa.',
        },
        th: {
            orderDetails: 'รายละเอียดการสั่งซื้อ',
            orderError: 'ข้อผิดพลาดในการสั่งซื้อ',
            orderErrorMessage: 'มีข้อผิดพลาดเกิดขึ้นกับคำสั่งซื้อของคุณ',
            contactsStaff: 'กรุณาติดต่อพนักงานร้าน',
            inPreparation: 'กำลังเตรียม',
            pickupNo: 'หมายเลขการเบิก',
            orderSuccessMessage: 'คำสั่งซื้อของคุณสำเร็จแล้ว',
            pending: 'รอดำเนินการ',
            pendingMessage: 'โปรดรอให้ร้านอาหารยืนยัน',
            refresh: 'คุณสามารถรีเฟรชหน้าภายหลัง',
            dineIn: 'ทานในร้าน',
            takeAway: 'ห่อกลับ',
            delivery: 'Delivery',
            tableNo: 'หมายเลขโต๊ะ',
            orderTime: 'เวลาสั่งซื้อ',
            paymentId: 'รหัสการชำระเงิน:',
            menuItems: 'รายการเมนู',
            notes: 'หมายเหตุ',
            gst: 'ภาษีมูลค่าเพิ่ม',
            surcharge: 'ค่าธรรมเนียมเพิ่ม',
            pointsRedeemed: 'คะแนนที่ใช้',
            total: 'รวม (รวมภาษีมูลค่าเพิ่ม)',
            done: 'เสร็จแล้ว',
            orderNo: 'หมายเลขคำสั่งซื้อ: ',
            serviceType: 'ประเภทบริการ',
            sendingOrder: 'กําลังส่งคำสั่งซื้อ...',
            orderSuccessTitle: 'สั่งซื้อสำเร็จ',
            orderSuccessModalMessage: 'สั่งซื้อสำเร็จ โปรดไปที่เคาน์เตอร์เพื่อชำระเงินหลังจากรับประทานอาหาร',
        },
    };

    Object.keys(translations).forEach(lang => {
        if (lang !== 'en' && !translations[lang].sendingOrder) {
            translations[lang].sendingOrder = translations.en.sendingOrder;
        }
    });

    const ui = (key) => translations[uiLanguage] ? translations[uiLanguage][key] : translations['en'][key];

    const getServiceModeName = (serviceModeValue) => {
        if (Number(serviceModeValue) === 0) return 'Dine-in';
        if (Number(serviceModeValue) === 2) return 'Delivery';
        return 'Take-away';
    };

    const getServiceModeLabel = () => {
        if (serviceMode === 'Dine-in') return ui('dineIn');
        if (serviceMode === 'Delivery') return ui('delivery');
        return ui('takeAway');
    };

    useEffect(() => {
        window.history.pushState(null, '', window.location.href);
    
        const handlePopState = (event) => {
          setCartFromRemote([]);
          if (tableNumber !== 'Take-away') {
            navigate(`/qr_order/${restaurantUrl}/${tableNumber}`, {
              state: { orderingMore: false },
            });
          } else {
            navigate(`/qr_order/${restaurantUrl}/take_away`, {
              state: { orderingMore: false },
            });
          }
        };
    
        window.addEventListener('popstate', handlePopState);
    
        return () => {
          window.removeEventListener('popstate', handlePopState);
        };
      }, [setCartFromRemote, navigate, tableNumber, restaurantUrl]);
    
    const handleLoadingComplete = () => {
        setIsLoading(false);
    };
    
    useEffect(() => {
        if (orderId) {
            // 检查URL查询参数
            const fromPayment = searchParams.get('from') === 'payment';
            
            if (fromPayment) {
                // 如果是从支付页面跳转回来，显示进度条并延迟5秒获取订单
                setIsLoading(true);
                setTimeout(() => {
                    getOrder(orderId);
                }, 5000);
            } else {
                // 否则直接获取订单数据
                getOrder(orderId);
            }
        }
    }, [orderId, searchParams]);
    
    const ClickDoneButton = async () => {
        try {
            setCartFromRemote([]);
            if(tableNumber!=='Take-away'){
                navigate(`/qr_order/${restaurantUrl}/${tableNumber}`,{ state: { orderingMore: true } });
            }
            else{
                navigate(`/qr_order/${restaurantUrl}/take_away`,{ state: { orderingMore: false } });
            }
            
        } catch (error) {
            console.error(error);
        }
    }

    const getOrder = async (orderId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/fetch-order/${orderId}`);
            if (!resultMounted.current) return;
            
            if (response.status === 200) {
                setCartFromRemote([]);
                
                setStoreName(response.data.storeName.StoreName);
                setUsePickupSlip(response.data.usePickupSlip);
         
                setPayLaterReminderEnable(response.data.payLaterReminderEnable);
                setPayLaterReminderText(response.data.payLaterReminderText);
                
                setPayFirstReminderEnable(response.data.payFirstReminderEnable);
                setPayFirstReminderText(response.data.payFirstReminderText);
                
                setTakeawayReminderEnable(response.data.takeawayReminderEnable);
                setTakeawayReminderText(response.data.takeawayReminderText);
                
                setOrderTime(response.data.orderResult.OrderTime);
             
                setOrderSuccess(response.data.orderResult.Success);
                setOrderEnrichNo(response.data.orderResult.OrderEnrichNo)
                setTableNumber(response.data.orderResult.TableNo);
                if (Number(response.data.orderResult.Paid) !== 0 && response.data.orderResult.TableNo) {
                    setDineInGuestCount(null);
                }
                
                setPaymentId(response.data.orderResult.StripePaymentId);
                setOrderDetails(response.data.orderResult.OrderDetails);
                setSurcharges(response.data.orderResult.Surcharge);
                setTotalAmount(response.data.orderResult.TotalAmount);
                setTotalGST(response.data.orderResult.TotalGST);
                setNotes(response.data.orderResult.Notes);
                setPromotionTitle(response.data.orderResult.PromotionTitle || '');
                setPromotionAmount(response.data.orderResult.PromotionAmount || 0);
                setCrmPoints(response.data.crmPoints || null);
                
                // Calculate total item quantity
                const totalItems = response.data.orderResult.OrderDetails.reduce((sum, [_, mainItem]) => {
                    return sum + mainItem.quantity;
                }, 0);
                setTotalItemQuantity(totalItems);
                
                // Set Customer Menu Show Price
                setShowPriceInCustomerMenu(response.data.showPriceInCustomerMenu !== 0);

                const currentServiceMode = getServiceModeName(response.data.orderResult.ServiceMode);
                setServiceMode(currentServiceMode);

                // 如果订单成功，根据支付方式和服务类型显示相应的成功弹窗
                if (response.data.orderResult.Success === 1) {
                    const hasPayment = response.data.orderResult.StripePaymentId !== null;
                    
                    if (hasPayment && response.data.payFirstReminderEnable === 1) {
                        // 已支付订单 - 显示 Pay First Reminder
                        setShowSuccessModal(true);
                    } else if (!hasPayment && currentServiceMode === 'Dine-in' && response.data.payLaterReminderEnable === 1) {
                        // 未支付的堂食订单 - 显示 Pay Later Reminder
                        setShowSuccessModal(true);
                    } else if (!hasPayment && currentServiceMode === 'Take-away' && response.data.takeawayReminderEnable === 1) {
                        // 未支付的外卖订单 - 显示 Take-away Reminder
                        setShowSuccessModal(true);
                    }
                }
            }
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    }

    const getDisplayedSurchargeAmount = () => {
        const surchargeRate = Number(surcharges || 0);
        if (surchargeRate <= 0) return 0;
        const eligibleAmountCents = Number(crmPoints?.eligibleAmountCents || 0);
        if (Number(crmPoints?.redeemAmountCents || 0) > 0 && eligibleAmountCents > 0) {
            const remainingEligibleAmountCents = Math.max(
                0,
                eligibleAmountCents - Number(crmPoints.redeemAmountCents || 0),
            );
            return Math.round(remainingEligibleAmountCents * surchargeRate / 100) / 100;
        }
        const amount = Number(totalAmount || 0);
        return amount / (1 + surchargeRate / 100) * (surchargeRate / 100);
    };


    return (
    <div className="container" style={{background:'#f1f1f1', minHeight: '100vh'}}>
        {isLoading ? (
            <LoadingOverlay 
                loadingText={ui('sendingOrder')}
                onComplete={handleLoadingComplete}
            />
        ) : (
        <>
        <div className="header">
        <div className="box">
            <div className="left">
                {storeName}
            </div>
            <div className="right">
                <div className="item">
                    <a onClick={ClickDoneButton}>
                        <img src="/img/icon6.svg"/>
                    </a>
                </div>
            </div>
        </div>
        </div>

        <header className="mui-bar mui-bar-transparent">
            <h1 className="mui-title">{ui('orderDetails')}</h1>
        </header>
        <div style= {{height: '44px'}}></div>
        <div>
       
        <div className="container-fluid">
            <div className="zdy_card2">
            {
        orderSuccess !== 1 ?
        <div>
            <div className="text1">{ui('orderError')}</div>
            <div className="text2">{ui('orderErrorMessage')}</div>
            <div className="text2"> {ui('contactsStaff')}</div>
        </div>
        :
        orderEnrichNo ?
            <div>
                
            {(usePickupSlip === 1 && serviceMode === 'Take-away')? (
   
                   
                    <div className="text1">{ui('pickupNo')} {orderEnrichNo.slice(-4)}</div>
            ) : (
                <div className="text1" >{ui('inPreparation')}</div>
            )}

                <div className="text2">{ui('orderSuccessMessage')}</div>
            </div>
            :
            <div>
                <div className="text1">{ui('pending')}</div>
                <div className="text2">{ui('pendingMessage')}</div>
                <div className="text2">{ui('refresh')}</div>
            </div>
}

                <ul>
                    <li>
                        <span  style={{fontWeight:'bold'}}> {getServiceModeLabel()}</span>
                       
                    </li>
                    {serviceMode === 'Dine-in' && (<li>
                        <span>{ui('tableNo')}</span>
                        <span>{tableNumber}</span>
                    </li>)}
                    {serviceMode === 'Take-away' && (<li>
                        <span>{ui('serviceType')}</span>
                        <span>{getServiceModeLabel()}</span>
                    </li>)}
                    {serviceMode === 'Delivery' && (<li>
                        <span>{ui('serviceType')}</span>
                        <span>{getServiceModeLabel()}</span>
                    </li>)}
                    <li>
                        <span>{ui('orderTime')}</span>
                        <span>{orderTime}</span>
                    </li>
                    {orderEnrichNo&&<li>
                        <span>{ui('orderNo')}</span>
                        
                        <span >{orderEnrichNo}</span>
                    </li>}
                    {paymentId&&
                   <li style={{ display: 'flex', justifyContent: 'space-between' }}>
                   <span style={{  whiteSpace: 'nowrap' }}>{ui('paymentId')}</span>
                   <span style={{ fontWeight: 'normal', fontSize: '12px', textAlign: 'right' }}>{paymentId}</span>
               </li>
               }
               
                </ul>
            </div>
            <div className="zdy_card2">
                <div className="title">
                    <span>{ui('menuItems')}</span>
                </div>
                <ul>
                {OrderDetails && OrderDetails.map(([_, item, ...extraItems]) => (
         
                <>
            <li key={item.mainItemCode}>
                <span style={{ fontWeight: "600" ,marginRight:"30px",marginBottom:"3px"}}>{item.mainItemDescription} x {item.quantity}</span>
                <span>{showPriceInCustomerMenu ? `$${(item.quantity * item.price).toFixed(2)}` : '\u00A0'}</span>
            </li>
            {extraItems.length === 0 && <li style={{ borderBottom: "1px solid #e6e6e6" }}></li>}
            {extraItems.map((extraItem, index) => (
                <li key={extraItem.itemCode}>
                    <span style={{paddingLeft:"14px",fontSize:"13px",marginTop:"-12px"}}> {extraItem.itemDescription} x {extraItem.quantity}</span>
                    <span style={{fontSize:"13px",marginTop:"-12px"}}>{showPriceInCustomerMenu ? `$${(extraItem.quantity * extraItem.price).toFixed(2)}` : '\u00A0'}</span>
                </li>
            ))}
            {extraItems.length !== 0 && <li style={{ borderBottom: "1px solid #e6e6e6" }}></li>}
        </>
                ))}
                  </ul>
            </div>
            {notes&&<div className="zdy_card2">
                <div className="title">
                    <span>{ui('notes')}</span>
                </div>
                        <ul>
                            <li>
                            
                                    <span>{notes}</span>
                                    
                            </li>
                        </ul>
            </div>}
            <div className="zdy_card2">
                <ul>
                    {promotionTitle && promotionAmount > 0 && (
                        <li style={{ color: 'rgb(252 158 86)' }}>
                            <span style={{ fontWeight: '600' }}>{promotionTitle}</span>
                            <span style={{ fontWeight: '600' }}>{showPriceInCustomerMenu ? `-$${parseFloat(promotionAmount).toFixed(2)}` : '\u00A0'}</span>
                        </li>
                    )}
                    {['Stripe', 'Tyro'].includes(crmPoints?.paymentGateway)
                        && Number(crmPoints?.redeemPoints || 0) > 0
                        && Number(crmPoints?.redeemAmountCents || 0) > 0 && (
                        <li style={{ color: '#2e7d32' }}>
                            <span>{ui('pointsRedeemed')} ({Number(crmPoints.redeemPoints).toLocaleString()})</span>
                            <span>{showPriceInCustomerMenu ? `-$${(Number(crmPoints.redeemAmountCents) / 100).toFixed(2)}` : '\u00A0'}</span>
                        </li>
                    )}
                    {(surcharges&& surcharges> 0 )?(
                    <li>
                        <span>{ui('surcharge')}</span>
                        <span>{showPriceInCustomerMenu ? `$${getDisplayedSurchargeAmount().toFixed(2)}` : '\u00A0'}</span>

                    </li>):null}
                    <li>
                        <span style={{fontWeight: 'bold'}}>{showPriceInCustomerMenu ? ui('total') : `Total Items: ${totalItemQuantity}`}</span>
                        <b>{showPriceInCustomerMenu ? `$${totalAmount.toFixed(2)}` : '\u00A0'}</b>
                    </li>
                    
                </ul>
            </div>
        </div>
        <div style={{height: '70px'}}></div>
        {orderEnrichNo &&(<div className="fixed-bottom bg-white" style={{padding: '8px 16px'}}>
            <button onClick={() => ClickDoneButton()} type="button" className="btn btn-warning btn-block">{ui('done')}</button>
           
        </div>)}
        </div>
        </>
        )}
        
        {/* 成功弹窗 */}
        {showSuccessModal && (
            <div className="success-modal-overlay" onClick={() => setShowSuccessModal(false)}>
                <div className="success-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="success-modal-content">
                        <div className="success-icon">
                            <img src="/img/check-mark.png" alt="Success" width="60" height="60" />
                        </div>
                        <div className="success-message">
                            {paymentId && payFirstReminderText && payFirstReminderText.length > 0 
                                ? payFirstReminderText 
                                : !paymentId && serviceMode === 'Take-away' && takeawayReminderText && takeawayReminderText.length > 0
                                    ? takeawayReminderText
                                    : !paymentId && serviceMode === 'Dine-in' && payLaterReminderText && payLaterReminderText.length > 0
                                        ? payLaterReminderText
                                        : ui('orderSuccessModalMessage')}
                        </div>
                        <button className="success-close-btn" onClick={() => setShowSuccessModal(false)}>
                            ×
                        </button>
                    </div>
                </div>
            </div>
        )}
        </div>
    );

}
export default OrderResult;
